export enum NotificacionEnum {
    Informacion = 'informacion',
    Exito = 'exito' ,
    Advertencia = 'advertencia',
    Error = 'error'
}
  